import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Coverage } from "@/components/Coverage";
import { Savings } from "@/components/Savings";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { BecomeClient } from "@/components/BecomeClient";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="bg-white font-sans text-brand-navy antialiased">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Coverage />
        <Savings />
        <Testimonials />
        <Faq />
        <BecomeClient settings={settings} />
        <QuoteForm />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
